export function createWorker() {
    // For it to work we had to:
    // - Configure a proxy so that the worker script below can be access from *.malt.*/ (see the service
    //   `navbar-sharedworker-js` in app-config:helm/spring-apps-template/configurations/navbar/values.yaml
    //   Indeed: SharedWorkers may only be loaded from the same origin, so it wouldn't work to load them from
    //   cdn.*.malt.com as are other scripts (the "same origin" policy being relative to the host executing the
    //   scripts, and not the host serving them).
    // - Configure Webpack's publicPath so that it knows that assets are located under /navbar-assets/static/
    //   on non-dev environments (see vue.config.js).

    // @ts-ignore
    return new SharedWorker(new URL('../../../notifications.shared-worker.ts', import.meta.url) /* webpackChunkName: 'navbar-worker.js' */);
}
